/* 24.10.2026 — Sepet çekmecesi (Tasarım 18)
   - Çerçeve / boyut değişimi: satır anında (iyimser) güncellenir; arkada yeni varyant eklenir, eski satır (key) silinir.
     Shopify yeni satırı listenin başına koyar → ekrandaki sıra sessionStorage'da tutulup her çizimden sonra korunur;
     görseller yeni çizime taşınır (yeniden yüklenip yanıp sönmez), kaydırma konumu korunur.
   - Kargoya veriliş tarihi, kaldır + geri al, boyut/çerçeve paneli, tek satır çerçeve önizlemesi.
   - 25.10.2026: adet seçici (anında güncellenir, dokunuşlar birleşir); Cam seçeneği (Malzeme). */
(() => {
  const SECTIONS = ["mini-cart-drawer", "cart-notification-count"];
  const SIRA_KEY = "tl_sira";

  async function post(url, body) {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    const json = await response.json();
    if (!response.ok || json.status) {
      throw new Error(json.description || json.message || "Sepet güncellenemedi");
    }
    return json;
  }

  function render(state) {
    const cartNotification = document.querySelector("cart-notification");
    if (!cartNotification) return;
    cartNotification.inDrawerUpdate = true;
    cartNotification.renderContents(state);
  }

  const govde = () => document.querySelector("#mini-cart-drawer .tl-c__govde");

  /* ---- Ekrandaki sıra: Shopify değişen/yeni satırı başa koyar; kullanıcının gördüğü sırayı koru ---- */
  function siraOku() {
    try { return JSON.parse(sessionStorage.getItem(SIRA_KEY) || "[]").map(String); } catch (e) { return []; }
  }

  function siraYaz(sira) {
    try { sessionStorage.setItem(SIRA_KEY, JSON.stringify(sira)); } catch (e) {}
  }

  function siralamayiUygula() {
    const form = document.querySelector("#mini-cart-drawer form#cart");
    if (!form) return;
    const satirlar = [...form.querySelectorAll(":scope > [data-tl-satir]")];
    const kullanildi = new Set();
    const bilinen = [];
    siraOku().forEach((id) => {
      const satir = satirlar.find((s) => s.dataset.variantId === id && !kullanildi.has(s));
      if (satir) { kullanildi.add(satir); bilinen.push(satir); }
    });
    // sırada olmayanlar (yeni eklenenler) Shopify'daki gibi en üstte
    const hedef = [...satirlar.filter((s) => !kullanildi.has(s)), ...bilinen];
    if (hedef.some((s, i) => satirlar[i] !== s)) hedef.forEach((s) => form.appendChild(s));
    siraYaz(hedef.map((s) => s.dataset.variantId));
  }

  /* ---- Görselleri yeni çizime taşı: aynı adresli görsel yeniden yüklenip yanıp sönmesin ---- */
  // önceki çizimdeki görsel öğeleri; eşleşme o anki src'ye göre (iyimser güncelleme / önizleme src'yi değiştirmiş olabilir)
  let sonGorseller = [];

  function gorselleriKaydet() {
    sonGorseller = [...document.querySelectorAll("#mini-cart-drawer img")];
  }

  function gorselleriTasi() {
    document.querySelectorAll("#mini-cart-drawer img").forEach((yeni) => {
      const src = yeni.getAttribute("src");
      const eski = src && sonGorseller.find((img) => !img.isConnected && img.getAttribute("src") === src);
      if (!eski) return;
      sonGorseller.splice(sonGorseller.indexOf(eski), 1);
      [...eski.attributes].forEach((a) => { if (!yeni.hasAttribute(a.name)) eski.removeAttribute(a.name); });
      [...yeni.attributes].forEach((a) => { if (eski.getAttribute(a.name) !== a.value) eski.setAttribute(a.name, a.value); });
      yeni.replaceWith(eski);
    });
  }

  /* ---- Dokunulan seçimi satıra hemen yansıt (sunucu cevabını beklemeden) ---- */
  function iyimserGuncelle(satir, secim) {
    if (!satir) return;
    const d = secim.dataset;
    const img = satir.querySelector("[data-tl-onizle-img]") || satir.querySelector(".tl-c13__gorsel img");
    if (img && d.gorsel && img.getAttribute("src") !== d.gorsel) {
      img.removeAttribute("srcset");
      img.src = d.gorsel;
    }
    if (d.ust) satir.querySelector(".tl-panel-ac__deger")?.replaceChildren(d.ust);
    if (d.alt) satir.querySelector(".tl-panel-ac__fiyat")?.replaceChildren(d.alt);
    if (d.fiyat) satir.querySelector(".tl-c13__fiyat strong")?.replaceChildren(d.fiyat);
    // üstü çizili fiyat + yüzde: Cam'da indirim yok → gizlenir (yanlış fiyatın yanında eski indirim kalmasın);
    // Cam'dan indirimli seçeneğe geçince satır sonradan uzamasın diye anında eklenir
    const fiyatKutu = satir.querySelector(".tl-c13__fiyat");
    let indirim = fiyatKutu?.querySelector(":scope > span");
    if (fiyatKutu && "eski" in d) {
      if (d.eski) {
        if (!indirim) {
          indirim = document.createElement("span");
          indirim.append(document.createElement("s"), document.createElement("em"));
          fiyatKutu.append(indirim);
        }
        const s = indirim.querySelector("s");
        if (s?.lastChild?.nodeType === Node.TEXT_NODE) s.lastChild.textContent = d.eski;
        else s?.append(d.eski);
        if (d.yuzde) indirim.querySelector("em")?.replaceChildren("%" + d.yuzde);
        indirim.hidden = false;
      } else if (indirim) {
        indirim.hidden = true;
      }
    }
    if (d.tur) satir.querySelector(".tl-c13__tur .tl-tur-ad")?.replaceChildren(d.tur);
    if (d.cerceveDurum && d.cerceveDurum !== "Çerçevesiz") satir.querySelector(".tl-teksatir")?.setAttribute("hidden", "");
    if (d.cerceveDurum === "Çerçeveli") {
      const tur = satir.querySelector(".tl-c13__tur");
      if (tur && !tur.querySelector(".tl-cerceveli-isaret")) {
        const ayrac = document.createElement("span");
        ayrac.className = "tl-ayrac";
        ayrac.textContent = " · ";
        const isaret = document.createElement("span");
        isaret.className = "tl-cerceveli-isaret";
        isaret.textContent = "Çerçeveli ✓";
        tur.append(ayrac, isaret);
      }
    } else if (d.cerceveDurum) {
      satir.querySelectorAll(".tl-c13__tur .tl-ayrac, .tl-c13__tur .tl-cerceveli-isaret").forEach((e) => e.remove());
    }
    secim.closest(".tl-panel__grid")?.querySelectorAll(".tl-panel__opt").forEach((o) => o.setAttribute("aria-pressed", String(o === secim)));
    // 26.10.2026: panelden seçimde panel açık kalır (müşteri × / dışarı / Esc ile kendisi kapatır)
    if (!secim.closest(".tl-panel")) panelleriKapat();
    satir.classList.add("is-guncelleniyor");
  }

  async function swapVariant(trigger, newId) {
    const key = trigger.dataset.key;
    const line = trigger.closest(".cart-notification-product");
    // satırın adedi anında değişmiş olabilir (sunucuya henüz gitmemiş) → ekrandaki adet esas
    const quantity = parseInt(line?.dataset.qty || trigger.dataset.qty, 10) || 1;
    const eskiId = line?.dataset.variantId;
    const panel = trigger.closest(".tl-panel");
    // önceki değişim sunucudayken gelen seçim yok sayılır (panel o sırada dokunmaya kapalı; aynı tablodan iki satır oluşmasın)
    if (line?.classList.contains("is-guncelleniyor")) return;
    if (!key || !newId || key.split(":")[0] === String(newId)) {
      if (!panel) panelleriKapat();
      return;
    }
    const bekleyen = miktarlar.get(key);
    if (bekleyen) { clearTimeout(bekleyen.zaman); miktarlar.delete(key); }

    const kaydirma = govde()?.scrollTop || 0;
    iyimserGuncelle(line, trigger);
    panel?.setAttribute("aria-busy", "true");
    // değişen satır ekrandaki yerini korusun
    const sira = siraOku();
    const yer = sira.indexOf(String(eskiId));
    if (yer >= 0) { sira[yer] = String(newId); siraYaz(sira); }

    const cizimSonrasi = (odakId) => {
      zenginlestir();
      const g = govde();
      if (g) g.scrollTop = kaydirma;
      const ac = document.querySelector(`#mini-cart-drawer [data-tl-satir][data-variant-id="${odakId}"] .tl-panel-ac`);
      // panelden seçildiyse yeniden çizilen satırda panel açık gelir, odak seçili seçenekte
      const yeniPanel = panel && ac ? document.getElementById(ac.getAttribute("aria-controls")) : null;
      if (yeniPanel) {
        ac.setAttribute("aria-expanded", "true");
        yeniPanel.hidden = false;
        paneliKonumla(ac, yeniPanel);
        (yeniPanel.querySelector('[aria-pressed="true"]') || ac).focus({ preventScroll: true });
      } else {
        ac?.focus({ preventScroll: true });
      }
    };

    try {
      await post(`${routes.cart_add_url}.js`, { items: [{ id: Number(newId), quantity }] });
      const state = await post(`${routes.cart_change_url}.js`, {
        id: key,
        quantity: 0,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      });
      render(state);
      cizimSonrasi(String(newId));
    } catch (e) {
      // sepetin gerçek hâlini yeniden çiz, hatayı satırda göster
      try {
        const sections = await (await fetch(`${window.location.pathname}?sections=${SECTIONS.join(",")}`)).json();
        if (yer >= 0) { const s = siraOku(); s[yer] = String(eskiId); siraYaz(s); }
        render({ sections });
        cizimSonrasi(String(eskiId));
      } catch (e2) {
        line?.classList.remove("is-guncelleniyor");
      }
      const hata = document.querySelector(`#mini-cart-drawer [data-tl-satir][data-variant-id="${eskiId}"] .tl-degistir-hata`);
      if (hata) {
        hata.textContent = e.message;
        hata.hidden = false;
      }
    }
  }

  document.addEventListener("change", (event) => {
    const select = event.target.closest("select[data-tl-degistir]");
    if (!select) return;
    // cart-notification'ın change dinleyicisi bunu adet değişikliği sanmasın
    event.stopPropagation();
    swapVariant(select, select.value);
  }, true);

  document.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-tl-degistir]");
    if (!button) return;
    event.preventDefault();
    swapVariant(button, button.dataset.variant);
  });

  /* ---- Adet: sayı, satır fiyatı ve toplamlar anında değişir; hızlı dokunuşlar birleşip tek istekle gider ---- */
  const MIKTAR_BEKLE = 400;
  const miktarlar = new Map(); // satır key → { hedef, zaman, gidiyor, tekrar }

  function para(kurus) {
    return `${(kurus / 100).toLocaleString("en-US", { maximumFractionDigits: 2 })}TL`;
  }

  function miktarSatiri(key) {
    return [...document.querySelectorAll("#mini-cart-drawer [data-tl-miktar]")].find((k) => k.dataset.key === key)?.closest("[data-tl-satir]");
  }

  function miktariGoster(satir, adet) {
    const kutu = satir?.querySelector("[data-tl-miktar]");
    const once = Number(satir?.dataset.qty) || 1;
    if (!kutu || adet === once) return;
    const fark = adet - once;
    const birim = Number(kutu.dataset.birim) || 0;
    const birimEski = Number(kutu.dataset.birimEski) || 0;
    satir.dataset.qty = String(adet);
    kutu.querySelector("[data-tl-miktar-sayi]").textContent = String(adet);
    kutu.querySelector('[data-tl-miktar-degis="-1"]').disabled = adet <= 1;
    satir.querySelector(".tl-c13__fiyat strong")?.replaceChildren(para(birim * adet));
    const eski = satir.querySelector(".tl-c13__fiyat > span s");
    if (eski?.lastChild && birimEski) eski.lastChild.textContent = para(birimEski * adet);
    const arttir = (nitelik, artis, yaz) => {
      const el = document.querySelector(`#mini-cart-drawer [${nitelik}]`);
      if (!el) return;
      const yeni = Number(el.getAttribute(nitelik)) + artis;
      el.setAttribute(nitelik, String(yeni));
      el.textContent = yaz(yeni);
    };
    arttir("data-tl-toplam", fark * birim, para);
    if (birimEski > birim) arttir("data-tl-indirim", fark * (birimEski - birim), (t) => `${para(t)} indirim`);
    arttir("data-tl-adet-toplam", fark, (t) => `(${t})`);
  }

  async function miktarGonder(key) {
    const d = miktarlar.get(key);
    if (!d) return;
    if (d.gidiyor) { d.tekrar = true; return; }
    d.gidiyor = true;
    const hedef = d.hedef;
    const kaydirma = govde()?.scrollTop || 0;
    const odak = document.activeElement?.closest?.("[data-tl-miktar-degis]")?.dataset.tlMiktarDegis;
    const cizimSonrasi = () => {
      zenginlestir();
      const g = govde();
      if (g) g.scrollTop = kaydirma;
      const satir = miktarSatiri(key);
      if (odak && satir) {
        const butonlar = [...satir.querySelectorAll("[data-tl-miktar-degis]")];
        (butonlar.find((b) => b.dataset.tlMiktarDegis === odak && !b.disabled) || butonlar.find((b) => !b.disabled))?.focus({ preventScroll: true });
      }
    };
    try {
      const state = await post(`${routes.cart_change_url}.js`, {
        id: key,
        quantity: hedef,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      });
      render(state);
      cizimSonrasi();
    } catch (e) {
      // sepetin gerçek hâlini yeniden çiz, hatayı satırda göster
      miktarlar.delete(key);
      try {
        const sections = await (await fetch(`${window.location.pathname}?sections=${SECTIONS.join(",")}`)).json();
        render({ sections });
        cizimSonrasi();
      } catch (e2) {}
      const hata = miktarSatiri(key)?.querySelector(".tl-degistir-hata");
      if (hata) {
        hata.textContent = e.message;
        hata.hidden = false;
      }
      return;
    }
    d.gidiyor = false;
    if (miktarlar.get(key) !== d) return;
    if (d.tekrar && !d.zaman) {
      d.tekrar = false;
      miktarGonder(key);
    } else if (!d.zaman && d.hedef === hedef) {
      miktarlar.delete(key);
    }
  }

  document.addEventListener("click", (event) => {
    const buton = event.target.closest("[data-tl-miktar-degis]");
    if (!buton) return;
    event.preventDefault();
    const kutu = buton.closest("[data-tl-miktar]");
    const satir = kutu?.closest("[data-tl-satir]");
    const key = kutu?.dataset.key;
    if (!satir || !key) return;
    const once = Number(satir.dataset.qty) || 1;
    const adet = Math.max(1, once + Number(buton.dataset.tlMiktarDegis));
    if (adet === once) return;
    satir.querySelector(".tl-degistir-hata")?.setAttribute("hidden", "");
    miktariGoster(satir, adet);
    const d = miktarlar.get(key) || { hedef: adet, zaman: null, gidiyor: false, tekrar: false };
    d.hedef = adet;
    clearTimeout(d.zaman);
    d.zaman = setTimeout(() => {
      d.zaman = null;
      miktarGonder(key);
    }, MIKTAR_BEKLE);
    miktarlar.set(key, d);
  });

  // Bekleyen adet değişikliği kaybolmasın: ödemeye geçmeden önce gönder, sayfadan çıkarken de arkadan yolla
  function bekleyenAdetler() {
    const updates = {};
    miktarlar.forEach((d, key) => {
      clearTimeout(d.zaman);
      updates[key] = d.hedef;
    });
    miktarlar.clear();
    return updates;
  }

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (form.id !== "cart" || !form.closest("#mini-cart-drawer") || !miktarlar.size) return;
    event.preventDefault();
    const gonderen = event.submitter;
    try {
      await post(`${routes.cart_update_url}.js`, { updates: bekleyenAdetler() });
    } catch (e) {}
    form.requestSubmit(gonderen);
  }, true);

  // Sayfadan çıkarken: arkadan gönder (site dışına çıkılıyorsa) ve yeni sayfa için sakla.
  // Yeni sayfa bu gönderimden önce çizilmiş olabilir (Shopify linkleri önceden yüklüyor) → açılışta aynı adet bir kez daha
  // gönderilir (mutlak adet, tekrarı zararsız) ve çekmece açılmadan tazelenir.
  const ADET_KEY = "tl_adet_bekleyen";

  window.addEventListener("pagehide", () => {
    if (!miktarlar.size) return;
    const updates = bekleyenAdetler();
    try { sessionStorage.setItem(ADET_KEY, JSON.stringify({ updates, t: Date.now() })); } catch (e) {}
    const veri = new URLSearchParams();
    Object.entries(updates).forEach(([key, adet]) => veri.append(`updates[${key}]`, adet));
    navigator.sendBeacon(`${routes.cart_update_url}.js`, veri);
  });

  // renderContents çekmeceyi açar; bu çizim açmadan yalnızca içeriği ve rozeti yeniler
  function sessizCiz(state) {
    const cartNotification = document.querySelector("cart-notification");
    if (!cartNotification || !state.sections) return;
    const yaz = (id, bolum) => {
      const el = document.getElementById(id);
      if (el && state.sections[bolum]) el.innerHTML = cartNotification.getSectionInnerHTML(state.sections[bolum]);
    };
    yaz("mini-cart-drawer", "mini-cart-drawer");
    yaz("cart-notification-count", "cart-notification-count");
    yaz("cart-notification-count-mobile", "cart-notification-count");
    const countEl = document.getElementById("cart-notification-count");
    const srCount = countEl?.parentElement?.querySelector(".visually-hidden");
    if (countEl && srCount) srCount.textContent = srCount.textContent.replace(/\d+/, countEl.textContent.trim());
  }

  async function bekleyeniTamamla() {
    let kayit = null;
    try {
      kayit = JSON.parse(sessionStorage.getItem(ADET_KEY) || "null");
      sessionStorage.removeItem(ADET_KEY);
    } catch (e) {}
    if (!kayit || Date.now() - kayit.t > 60000) return;
    try {
      sessizCiz(await post(`${routes.cart_update_url}.js`, {
        updates: kayit.updates,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }));
    } catch (e) {}
  }

  /* ---- Tasarım 4: kargoya veriliş tarihi + kaldır/geri al ---- */
  // Sabit resmî tatiller (AA-GG). Dini bayramlar yıl yıl eklenmeli.
  const TATIL = ["01-01", "04-23", "05-01", "05-19", "07-15", "08-30", "10-29"];
  const AYLAR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
  const GERI_AL_KEY = "tl_geri_al";
  const GERI_AL_SURE = 15000;

  function isGunuEkle(gun) {
    const tarih = new Date();
    let eklenen = 0;
    while (eklenen < gun) {
      tarih.setDate(tarih.getDate() + 1);
      const ayGun = `${String(tarih.getMonth() + 1).padStart(2, "0")}-${String(tarih.getDate()).padStart(2, "0")}`;
      if (tarih.getDay() !== 0 && tarih.getDay() !== 6 && !TATIL.includes(ayGun)) eklenen++;
    }
    return tarih;
  }

  function tarihAraligi(min, max) {
    const ilk = isGunuEkle(min);
    const son = isGunuEkle(max);
    if (ilk.getMonth() === son.getMonth()) return `${ilk.getDate()}–${son.getDate()} ${AYLAR[son.getMonth()]}`;
    return `${ilk.getDate()} ${AYLAR[ilk.getMonth()]} – ${son.getDate()} ${AYLAR[son.getMonth()]}`;
  }

  function geriAlOku() {
    try {
      const kayit = JSON.parse(sessionStorage.getItem(GERI_AL_KEY) || "null");
      return kayit && Date.now() - kayit.t < GERI_AL_SURE ? kayit : null;
    } catch (e) {
      return null;
    }
  }

  function geriAlSil() {
    try { sessionStorage.removeItem(GERI_AL_KEY); } catch (e) {}
  }

  function zenginlestir() {
    gorselleriTasi();
    siralamayiUygula();
    gorselleriKaydet();
    // henüz sunucuya gitmemiş / yoldaki adetler: yeni çizim sunucunun eski adetini gösterir → yeniden uygula
    miktarlar.forEach((d, key) => miktariGoster(miktarSatiri(key), d.hedef));

    document.querySelectorAll("[data-tl-kargo-tarih]").forEach((el) => {
      el.textContent = tarihAraligi(Number(el.dataset.min) || 1, Number(el.dataset.max) || 3);
    });

    const bar = document.querySelector("[data-tl-geri-al]");
    if (!bar) return;
    const kayit = geriAlOku();
    if (!kayit) {
      bar.hidden = true;
      return;
    }
    bar.replaceChildren();
    const metin = document.createElement("span");
    metin.textContent = `“${kayit.ad}” sepetten çıkarıldı.`;
    const buton = document.createElement("button");
    buton.type = "button";
    buton.dataset.tlGeriAlButon = "";
    buton.textContent = "Geri al";
    bar.append(metin, buton);
    bar.hidden = false;
    setTimeout(() => {
      if (!geriAlOku()) bar.hidden = true;
    }, GERI_AL_SURE - (Date.now() - kayit.t));
  }

  // Kaldır'a basılınca satırı hatırla (cart-remove-button-2'nin kendi dinleyicisinden önce çalışır)
  document.addEventListener("click", (event) => {
    const remove = event.target.closest(".tl-c cart-remove-button-2");
    const line = remove?.closest("[data-tl-satir]");
    if (!line) return;
    const key = line.querySelector("[data-tl-miktar]")?.dataset.key;
    if (key && miktarlar.has(key)) {
      clearTimeout(miktarlar.get(key).zaman);
      miktarlar.delete(key);
    }
    try {
      sessionStorage.setItem(GERI_AL_KEY, JSON.stringify({
        id: Number(line.dataset.variantId),
        quantity: Number(line.dataset.qty) || 1,
        ad: line.dataset.ad,
        yer: siraOku().indexOf(String(line.dataset.variantId)),
        t: Date.now(),
      }));
    } catch (e) {}
  }, true);

  document.addEventListener("click", async (event) => {
    const buton = event.target.closest("[data-tl-geri-al-buton]");
    if (!buton) return;
    const kayit = geriAlOku();
    geriAlSil();
    if (!kayit) return;
    buton.disabled = true;
    // geri gelen ürün eski yerine dönsün
    if (kayit.yer >= 0) {
      const sira = siraOku().filter((id) => id !== String(kayit.id));
      sira.splice(Math.min(kayit.yer, sira.length), 0, String(kayit.id));
      siraYaz(sira);
    }
    try {
      const state = await post(`${routes.cart_add_url}.js`, {
        items: [{ id: kayit.id, quantity: kayit.quantity }],
        sections: SECTIONS,
        sections_url: window.location.pathname,
      });
      render(state);
    } catch (e) {
      buton.closest("[data-tl-geri-al]").textContent = e.message;
    }
  });

  /* ---- 15 / 16: sticky paneli gibi açılan boyut + çerçeve paneli ---- */
  function panelleriKapat(haric) {
    document.querySelectorAll('[data-tl-panel-ac][aria-expanded="true"]').forEach((ac) => {
      if (ac === haric) return;
      ac.setAttribute("aria-expanded", "false");
      document.getElementById(ac.getAttribute("aria-controls"))?.setAttribute("hidden", "");
    });
  }

  function paneliKonumla(ac, panel) {
    const satir = panel.offsetParent;
    if (!satir) return;
    panel.style.top = `${ac.getBoundingClientRect().bottom - satir.getBoundingClientRect().top + 8}px`;
  }

  document.addEventListener("click", (event) => {
    // panelin sağ üstündeki ×: kapat, odağı seçim kutusuna geri ver
    const kapat = event.target.closest("[data-tl-panel-kapat]");
    if (kapat) {
      event.preventDefault();
      const panel = kapat.closest(".tl-panel");
      panelleriKapat();
      document.querySelector(`[data-tl-panel-ac][aria-controls="${panel?.id}"]`)?.focus();
      return;
    }
    const ac = event.target.closest("[data-tl-panel-ac]");
    if (ac) {
      event.preventDefault();
      const panel = document.getElementById(ac.getAttribute("aria-controls"));
      const acik = ac.getAttribute("aria-expanded") === "true";
      panelleriKapat(ac);
      ac.setAttribute("aria-expanded", String(!acik));
      panel.hidden = acik;
      if (!acik) {
        paneliKonumla(ac, panel);
        panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
        panel.querySelector('[aria-pressed="true"]')?.focus({ preventScroll: true });
      }
      return;
    }
    if (!event.target.closest(".tl-panel")) panelleriKapat();
  });

  // Esc önce paneli kapatsın (çekmece kapanmasın)
  document.addEventListener("keyup", (event) => {
    if (event.key !== "Escape") return;
    const ac = document.querySelector('[data-tl-panel-ac][aria-expanded="true"]');
    if (!ac) return;
    event.stopPropagation();
    panelleriKapat();
    ac.focus();
  }, true);

  /* ---- 18: tek satır yönlendirmedeki küçük fotoğraf büyük görseli çerçeveli/çerçevesiz arasında çevirir ---- */
  document.addEventListener("click", (event) => {
    const gor = event.target.closest("[data-tl-onizle-tek]");
    if (!gor) return;
    event.preventDefault();
    const satir = gor.closest("[data-tl-satir]");
    const img = satir?.querySelector("[data-tl-onizle-img]");
    if (!img || !gor.dataset.src) return;
    const acik = gor.getAttribute("aria-pressed") === "true";
    if (!img.dataset.orijinal) img.dataset.orijinal = img.getAttribute("src");
    img.removeAttribute("srcset");
    img.src = acik ? img.dataset.orijinal : gor.dataset.src;
    gor.setAttribute("aria-pressed", String(!acik));
    satir.classList.toggle("is-onizleme", !acik);
  });

  const drawer = document.getElementById("mini-cart-drawer");
  if (drawer) new MutationObserver(zenginlestir).observe(drawer, { childList: true });
  zenginlestir();
  bekleyeniTamamla();
})();
